// @flow

import React from 'react'
import styled from 'styled-components'
import { Radio } from 'antd'
import { mediaMin, mediaMax } from 'frontend_core/dist/styles/media'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import { clearFix } from 'components/styles/helpers'
import Colors from 'components/styles/colors'
import Icon from 'components/atoms/Icon'

const RadioListRecommendedWrapper = styled.div`
  ${mediaMin.phone`
    text-align: center;
  `};
`
const Container = styled.div`
  display: inline-block;

  .ant-radio-group {
    margin: ${spacing.small_3}px 0 0 -${spacing.small_2}px;
    text-align: center;
    ${mediaMin.phone`
      margin: ${spacing.small_3}px 0 0 -${spacing.medium}px;
    `};
  }
`
const RadioWrapper = styled.div`
  display: inline-block;
  margin: 0 0 0 ${spacing.small_2}px;
  vertical-align: top;
  ${mediaMin.phone`
    margin: 0 0 0 ${spacing.medium}px;
    span.ant-radio + * {
      font-size: ${fontSize.medium}px;
    }
  `} .ant-radio {
    float: none;
  }

  span.ant-radio + * {
    display: block;
    float: none;
    padding-left: 0;
    margin-left: 0;
    text-align: center;
    font-size: ${fontSize.small_3}px;
  }
`
const TextWrapper = styled.div`
  ${clearFix()};
`
const NotRecommended = styled.div`
  float: left;
  color: ${Colors.black};
  ${mediaMin.phone`
    font-size: ${fontSize.small_3}px;
    font-weight: bold;
  `};
`
const Recommended = styled.div`
  float: right;
  color: ${Colors.black};
  ${mediaMin.phone`
    font-size: ${fontSize.small_3}px;
    font-weight: bold;
  `};
`

export type PropTypes = {
  name: string,
  selectedValue?: ?number | string,
  onChange: Function,
  bold?: boolean,
}

const RadioGroup = Radio.Group

export default function RadioListRecommended(props: PropTypes) {
  const radioList = [
    {
      label: '1',
      value: 1,
    },
    {
      label: '2',
      value: 2,
    },
    {
      label: '3',
      value: 3,
    },
    {
      label: '4',
      value: 4,
    },
    {
      label: '5',
      value: 5,
    },
    {
      label: '6',
      value: 6,
    },
    {
      label: '7',
      value: 7,
    },
    {
      label: '8',
      value: 8,
    },
    {
      label: '9',
      value: 9,
    },
    {
      label: '10',
      value: 10,
    },
  ]

  return (
    <RadioListRecommendedWrapper>
      <Container>
        <TextWrapper>
          <NotRecommended>
            <Icon className="fa fa-caret-left" positionType="left" />
            {i18n.t('page.dashboard.reservation.notRecommended')}
          </NotRecommended>
          <Recommended>
            {i18n.t('page.dashboard.reservation.recommended')}
            <Icon className="fa fa-caret-right" positionType="right" />
          </Recommended>
        </TextWrapper>
        <RadioGroup
          onChange={e => props.onChange(e.target.value)}
          value={props.selectedValue}
        >
          {radioList.map((radio, index) => (
            <RadioWrapper key={`radioList_${index}`}>
              <Radio value={radio.value} name={props.name}>
                {radio.label}
              </Radio>
            </RadioWrapper>
          ))}
        </RadioGroup>
      </Container>
    </RadioListRecommendedWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/RadioListRecommended/index.jsx